<template>
  <v-container class="pt-0 pb-10" style="max-width: 400px">
    <div class="carrinho-bar">
      <span class="etapa" style="border-color: #b2b842">
        <v-icon color="#b2b842" size="13px">fa-circle</v-icon>
        <p class="text-circle lf">
          Condição <br />
          de edição
        </p>
      </span>
      <div class="bar"></div>
      <span :class="['etapa', etapa > 1 ? 'etp1' : 'etp0']">
        <v-icon :color="etapa > 1 ? colors[1] : colors[0]" size="13px">fa-circle</v-icon>
        <p class="text-circle pf">
          Objetos de <br />
          alteração
        </p>
      </span>
      <div class="bar"></div>
      <span :class="['etapa', etapa == 4 ? 'etp1' : 'etp0' && etapa == 5 ? 'etp2' : 'etp0']">
        <v-icon :color="etapa == 4 ? colors[1] : colors[0] && etapa == 5 ? colors[2] : colors[0]" size="13px">fa-circle</v-icon>
        <p class="text-circle pl">
          Processamento <br />
          da edição
        </p>
      </span>
    </div>
  </v-container>
</template>

<script>
export default {
    data() {
        return {
            colors: ['#FFFFFF', '#b2b842', '#D0021B']
        }
    },
    props: {
        etapa: Number
    }
};
</script>

<style lang="scss" scoped>
.carrinho-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: 10px 0;
  .etapa {
    color: #dadada;
    border: 1.5px solid #dadada;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 27px;
    text-align: center;
  }
  .status {
    font-size: 11px;
    color: #430f4a;
    font-weight: 500;
    background-color: #ced402;
    border: 1.5px solid #ced402;
    border-radius: 8px;
    width: 90px;
    height: 20px;
    line-height: 16px;
    text-align: center;
  }
  .bar {
    flex: 1;
    height: 1px;
    background-color: #dadada;
  }
  .text-circle {
    color: #777272;
    font-size: 13px;
    line-height: 16px;
    position: absolute;
    margin-top: 8px;
    margin-left: -10px;
  }
  .text-circle.lf {
    margin-left: -11px;
  }
  .text-circle.pf {
    margin-left: -15px;
  }
  .text-circle.pl {
    margin-left: -25px;
  }
  .legend-status {
    font-family: sans-serif;
    color: #979797b0;
    font-size: 10px;
    line-height: 17px;
    position: absolute;
  }
  .etapa.etp0 {
    border-color: #94999C;
  }
  .etapa.etp1 {
    border-color: #b2b842;
  }
  .etapa.etp2 {
    border-color: #D0021B;
  }
}
</style>